import {
    OCCUPATION_SET_VALID,
    OCCUPATION_SET_VALUE,
    GENDER_SET_VALID,
    GENDER_SET_VALUE,
    FIRST_NAME_SET_VALID,
    FIRST_NAME_SET_VALUE,
    EMAIL_SET_VALID,
    EMAIL_SET_VALUE,
    KRA_PIN_NUMBER_SET_VALID,
    KRA_PIN_NUMBER_SET_VALUE,
    MOBILE_NUMBER_SET_VALID,
    MOBILE_NUMBER_SET_VALUE,
    NATIONALITY_SET_VALID,
    NATIONALITY_SET_VALUE,
    SOURCE_OF_FUNDS_SET_VALID,
    SOURCE_OF_FUNDS_SET_VALUE,
    REINITIALIZE,
    FULL_ADDRESS_SET_VALID,
    FULL_ADDRESS_SET_VALUE,
    FORM_VALID_DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM,
    FORM_INVALID_DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM,
    SURNAME_SET_VALUE,
    SURNAME_SET_VALID,
    DOB_SET_VALUE,
    DOB_SET_VALID,
    ID_PASSPORT_SET_VALUE,
    ID_PASSPORT_SET_VALID,
    TITLE_SET_VALUE,
    TITLE_SET_VALID,
    POSTAL_ADDRESS_SET_VALUE,
    POSTAL_ADDRESS_SET_VALID,
    API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM,
    API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM,
    API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM,
    API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM,
    SOURCE_OF_OTHER_FUNDS_SET_VALUE,
    SOURCE_OF_OTHER_FUNDS_SET_VALID,
    SET_QUOTE_ID,
    ID_NUMBER_SET_VALUE,
    ID_NUMBER_SET_VALID,
    PASSPORT_SET_VALUE,
    PASSPORT_SET_VALID,
    EMPLOYER_SET_VALUE,
    EMPLOYER_SET_VALID,
    SALARY_RANGE_SET_VALUE,
    SALARY_RANGE_SET_VALID,
    SOURCE_OF_FUNDS_DETAILS_SET_VALUE,
    SOURCE_OF_FUNDS_DETAILS_SET_VALID,
    FUNDS_FROM_LEGITIMATE_SOURCE_SET_VALUE,
    FUNDS_FROM_LEGITIMATE_SOURCE_SET_VALID,
    INFO_TRUE_AND_CORRECT_SET_VALUE,
    INFO_TRUE_AND_CORRECT_SET_VALID,
    ACCEPT_PRIVACY_NOTICE_SET_VALUE,
    ACCEPT_PRIVACY_NOTICE_SET_VALID,
    PERSONAL_DETAIL_ID_SET_VALUE,
    PERSONAL_DETAIL_ID_SET_VALID,
    SET_REFERRED_VALUE,
    SET_REFERRED_VALID,
} from '../../actions/digitalSavings/personalDetails';
import { API_CALL_STATUS, FIELD_STATUS, FORM_STATUS } from '../status';

export const initPersonalDetails = {
    personalDetailId: 0,
    formStatus: FORM_STATUS.INVALID,
    apiCallStatus: null,
    quoteId: null,
    form: {
        title: { value: null, error: null, status: null },
        firstName: { value: null, error: null, status: null },
        surname: { value: null, error: null, status: null },
        dob: { value: null, error: null, status: null },
        email: { value: null, error: null, status: null },
        mobileNumber: { value: null, error: null, status: null },
        idPassport: { value: null, error: null, status: null },
        idNumber: { value: null, error: null, status: null },
        passportNumber: { value: null, error: null, status: null },
        kraPinNumber: { value: null, error: null, status: null },
        gender: { value: null, error: null, status: null },
        fullAddress: { value: null, error: null, status: null },
        postalBox: { value: null, error: null, status: null },
        nationality: { value: null, error: null, status: null },
        sourceOfFunds: { value: null, error: null, status: null },
        sourceOfOtherFunds: { value: null, error: null, status: null },
        sourceOfFundsDetails: { value: null, error: null, status: null },
        employerName: { value: null, error: null, status: null },
        salaryRange: { value: null, error: null, status: null },
        occupation: { value: null, error: null, status: null },
        fundsFromLegitimateSource: { value: false, error: null, status: 'valid' },
        informationIsTrueAndCorrect: { value: false, error: null, status: 'valid' },
        acceptPrivacyNotice: { value: false, error: null, status: 'valid' },
        referred: { value: null, error: null, status: null },
    },
};

export default (state = initPersonalDetails, action) => {
    const mapError = (error) => (error ? FIELD_STATUS.ERROR : FIELD_STATUS.VALID);
    const updateFormField = (fieldId, update) => ({
        ...state,
        form: {
            ...state.form,
            [fieldId]: update(state.form[fieldId]),
        },
    });

    switch (action.type) {
        case PERSONAL_DETAIL_ID_SET_VALUE:
            return { ...state, personalDetailId: action.value };

        case PERSONAL_DETAIL_ID_SET_VALID:
            return { ...state, personalDetailId: 0 };

        case FORM_VALID_DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.VALID };

        case FORM_INVALID_DIGITAL_SAVINGS_PERSONAL_DETAILS_FORM:
            return { ...state, formStatus: FORM_STATUS.INVALID };

        case API_INITIAL_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: null };

        case API_PENDING_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.PENDING };

        case API_SUCCESS_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.SUCCESS };

        case API_FAILURE_TRANSITION_PERSONAL_DETAILS_FORM:
            return { ...state, apiCallStatus: API_CALL_STATUS.FAILURE };

        case SET_QUOTE_ID:
            return { ...state, quoteId: action.value };

        case SET_REFERRED_VALUE:
            return updateFormField('referred', (field) => ({
                ...field,
                value: action.value,
            }));
        case SET_REFERRED_VALID:
            return updateFormField('referred', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FIRST_NAME_SET_VALUE:
            return updateFormField('firstName', (field) => ({
                ...field,
                value: action.value,
            }));

        case FIRST_NAME_SET_VALID:
            return updateFormField('firstName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case TITLE_SET_VALUE:
            return updateFormField('title', (field) => ({
                ...field,
                value: action.value,
            }));

        case TITLE_SET_VALID:
            return updateFormField('title', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case POSTAL_ADDRESS_SET_VALUE:
            return updateFormField('postalBox', (field) => ({
                ...field,
                value: action.value,
            }));

        case POSTAL_ADDRESS_SET_VALID:
            return updateFormField('postalBox', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SURNAME_SET_VALUE:
            return updateFormField('surname', (field) => ({
                ...field,
                value: action.value,
            }));

        case SURNAME_SET_VALID:
            return updateFormField('surname', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));
        case DOB_SET_VALUE:
            return updateFormField('dob', (field) => ({
                ...field,
                value: action.value,
            }));

        case DOB_SET_VALID:
            return updateFormField('dob', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case MOBILE_NUMBER_SET_VALUE:
            return updateFormField('mobileNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case MOBILE_NUMBER_SET_VALID:
            return updateFormField('mobileNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_PASSPORT_SET_VALUE:
            return updateFormField('idPassport', (field) => ({
                ...field,
                value: action.value,
            }));
        case ID_PASSPORT_SET_VALID:
            return updateFormField('idPassport', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_SET_VALUE:
            return updateFormField('passportNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case PASSPORT_SET_VALID:
            return updateFormField('passportNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMPLOYER_SET_VALUE:
            return updateFormField('employerName', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMPLOYER_SET_VALID:
            return updateFormField('employerName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ID_NUMBER_SET_VALUE:
            return updateFormField('idNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case ID_NUMBER_SET_VALID:
            return updateFormField('idNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case PASSPORT_SET_VALUE:
            return updateFormField('passportNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case PASSPORT_SET_VALID:
            return updateFormField('passportNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMPLOYER_SET_VALUE:
            return updateFormField('employerName', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMPLOYER_SET_VALID:
            return updateFormField('employerName', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case EMAIL_SET_VALUE:
            return updateFormField('email', (field) => ({
                ...field,
                value: action.value,
            }));
        case EMAIL_SET_VALID:
            return updateFormField('email', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case KRA_PIN_NUMBER_SET_VALUE:
            return updateFormField('kraPinNumber', (field) => ({
                ...field,
                value: action.value,
            }));
        case KRA_PIN_NUMBER_SET_VALID:
            return updateFormField('kraPinNumber', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case GENDER_SET_VALUE:
            return updateFormField('gender', (field) => ({
                ...field,
                value: action.value,
            }));
        case GENDER_SET_VALID:
            return updateFormField('gender', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FULL_ADDRESS_SET_VALUE:
            return updateFormField('fullAddress', (field) => ({
                ...field,
                value: action.value,
            }));
        case FULL_ADDRESS_SET_VALID:
            return updateFormField('fullAddress', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case OCCUPATION_SET_VALUE:
            return updateFormField('occupation', (field) => ({
                ...field,
                value: action.value,
            }));
        case OCCUPATION_SET_VALID:
            return updateFormField('occupation', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case NATIONALITY_SET_VALUE:
            return updateFormField('nationality', (field) => ({
                ...field,
                value: action.value,
            }));
        case NATIONALITY_SET_VALID:
            return updateFormField('nationality', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SOURCE_OF_FUNDS_SET_VALUE:
            return updateFormField('sourceOfFunds', (field) => ({
                ...field,
                value: action.value,
            }));
        case SOURCE_OF_FUNDS_SET_VALID:
            return updateFormField('sourceOfFunds', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SALARY_RANGE_SET_VALUE:
            return updateFormField('salaryRange', (field) => ({
                ...field,
                value: action.value,
            }));
        case SALARY_RANGE_SET_VALID:
            return updateFormField('salaryRange', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SOURCE_OF_OTHER_FUNDS_SET_VALUE:
            return updateFormField('sourceOfOtherFunds', (field) => ({
                ...field,
                value: action.value,
            }));

        case SOURCE_OF_OTHER_FUNDS_SET_VALID:
            return updateFormField('sourceOfOtherFunds', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case SOURCE_OF_FUNDS_DETAILS_SET_VALUE:
            return updateFormField('sourceOfFundsDetails', (field) => ({
                ...field,
                value: action.value,
            }));
        case SOURCE_OF_FUNDS_DETAILS_SET_VALID:
            return updateFormField('sourceOfFundsDetails', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case FUNDS_FROM_LEGITIMATE_SOURCE_SET_VALUE:
            return updateFormField('fundsFromLegitimateSource', (field) => ({
                ...field,
                value: action.value,
            }));
        case FUNDS_FROM_LEGITIMATE_SOURCE_SET_VALID:
            return updateFormField('fundsFromLegitimateSource', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case INFO_TRUE_AND_CORRECT_SET_VALUE:
            return updateFormField('informationIsTrueAndCorrect', (field) => ({
                ...field,
                value: action.value,
            }));
        case INFO_TRUE_AND_CORRECT_SET_VALID:
            return updateFormField('informationIsTrueAndCorrect', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case ACCEPT_PRIVACY_NOTICE_SET_VALUE:
            return updateFormField('acceptPrivacyNotice', (field) => ({
                ...field,
                value: action.value,
            }));
        case ACCEPT_PRIVACY_NOTICE_SET_VALID:
            return updateFormField('acceptPrivacyNotice', (field) => ({
                ...field,
                error: action.error,
                status: mapError(action.error),
            }));

        case REINITIALIZE:
            return initBiasharaFlexiCover;
        default:
            return state;
    }
};
